import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import {
  API_ENDPOINT,
  type ClientApiV1CourseCertificatesQueryString,
  useClientApiV1CourseCertificatesChallengeDetailQuery,
} from '../../resources/@types/courseSchema';
import useQueryOptionWithUserId from '../hooks/useQueryOptionWithUserId';

interface UseClientV1CourseCertificatesChallengeDetailQuery {
  query: {
    userId: number;
    courseId: number;
    voucherId: number;
  };
  options?: Parameters<typeof useClientApiV1CourseCertificatesChallengeDetailQuery>[0]['options'];
}

export function useCourseCertificatesChallengeDetailQuery({
  query,
  options,
}: UseClientV1CourseCertificatesChallengeDetailQuery) {
  const queryOption = useQueryOptionWithUserId(
    API_ENDPOINT.CLIENT_V1_COURSE_CERTIFICATES_CHALLENGE_DETAIL,
    query,
  );

  return useClientApiV1CourseCertificatesChallengeDetailQuery({
    queryKey: getCourseCertificatesChallengeDetailQueryKey(query),
    url: queryOption.url,
    options,
  });
}

export const getCourseCertificatesChallengeDetailQueryKey = (
  query: ClientApiV1CourseCertificatesQueryString,
): QueryKeyReturnType => [API_ENDPOINT.CLIENT_V1_COURSE_CERTIFICATES_CHALLENGE_DETAIL, query];
